var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avabgimg tc-avatar",style:(`backgroundImage: url(${_vm.srcPic});
backgroundSize:${_vm.bgstatus ? 'contain' : 'cover'};`)})
}
var staticRenderFns = []

export { render, staticRenderFns }